// MUI v4 (@material-ui/core)
import React from 'react';
import { SvgIcon } from '@material-ui/core';

const ReceiptLongSvg = (props) => (
  <SvgIcon viewBox="0 0 24 24" {...props}>
    {/* Escalamos de 960→24 y volteamos el eje Y. 
        0.025 = 24/960; uso 0.023 para dejar margen y que no se corte */}
    <g transform="scale(0.025,-0.025) ">
      <path d="M240-80q-50 0-85-35t-35-85v-120h120v-560l60 60 60-60 60 60 60-60 60 60 60-60 60 60 60-60 60 60 60-60v680q0 50-35 85t-85 35H240Zm480-80q17 0 28.5-11.5T760-200v-560H320v440h360v120q0 17 11.5 28.5T720-160ZM360-600v-80h240v80H360Zm0 120v-80h240v80H360Zm320-120q-17 0-28.5-11.5T640-640q0-17 11.5-28.5T680-680q17 0 28.5 11.5T720-640q0 17-11.5 28.5T680-600Zm0 120q-17 0-28.5-11.5T640-520q0-17 11.5-28.5T680-560q17 0 28.5 11.5T720-520q0 17-11.5 28.5T680-480ZM240-160h360v-80H200v40q0 17 11.5 28.5T240-160Zm-40 0v-80 80Z"/>
    </g>
  </SvgIcon>
);

export default ReceiptLongSvg;